import { IMedication, IPatient, NEW_MEDICATION_ID } from '../../caremap/ICareMap';
import { DuoPrescriptionBottleIcon } from '../../theme/Icons';
import { IStructuredFieldDef, IStructuredRecordDescriptor, IStructuredRecordIsPublicKey, IStructuredRecordPatientKey } from '../structured-records/StructuredRecordDescriptor';

export class MedicationDescriptor implements IStructuredRecordDescriptor<IMedication> {
    static inject = () => [];

    patientKey: IStructuredRecordPatientKey = 'medications';
    idField: keyof IMedication = 'id';
    newId = NEW_MEDICATION_ID;
    mode = 'edit-medication';
    routeSegment = 'medications';
    singular = 'Medication';
    plural = 'Medications';
    Icon = DuoPrescriptionBottleIcon;
    isPublicKey: IStructuredRecordIsPublicKey = 'medicationsIsPublic';

    trackingNoun = 'Medication';

    getName = (medication: IMedication) => medication.name;
    getSubtext = (medication: IMedication) => medication.instructions;

    buildTrackingProps = (medication: IMedication) => ({
        'Name': medication.name,
        'Has Instructions': Boolean(medication.instructions),
        'Has Dose': Boolean(medication.dose),
        'Has RX #': Boolean(medication.rxNumber),
        'Has Refills': Boolean(medication.refills),
        'Has Expiration Date': Boolean(medication.expiration),
        'Has Notes': Boolean(medication.notes),
        'No Longer Taking': Boolean(medication.noLongerTaking)
    });

    getRecords = (patient: IPatient) => patient.medications;
    withRecords = (patient: IPatient, records: IMedication[]): IPatient => ({ ...patient, medications: records });
    createBlank = (id: string): IMedication => ({ id, name: '' });

    fields: IStructuredFieldDef<IMedication>[] = [
        {
            key: 'name',
            label: 'Medication Name',
            type: 'text',
            required: true
        },
        {
            key: 'instructions',
            label: 'Instructions',
            type: 'textarea'
        },
        {
            key: 'dose',
            label: 'Dose',
            type: 'text'
        },
        {
            key: 'rxNumber',
            label: 'RX #',
            type: 'text'
        },
        {
            key: 'refills',
            label: 'Refills',
            type: 'text'
        },
        {
            key: 'expiration',
            label: 'Expiration Date',
            type: 'text'
        },
        {
            key: 'notes',
            label: 'Notes',
            type: 'textarea'
        },
        {
            key: 'noLongerTaking',
            label: 'No longer taking this medication',
            type: 'toggle'
        }
    ];
}
